import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import LoadScript from "vue-plugin-load-script";
import axios from "axios";
import VueAxios from "vue-axios";
import vuetify from "@/plugins/vuetify";

Vue.use(VueAxios, axios);
Vue.use(LoadScript);
Vue.use(require("vue-moment"));
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
